import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StorageMap } from '@ngx-pwa/local-storage';
import { CoreApiService } from 'app/shared/services/common/core-api-service';
import { ClientsToMmrView } from '../models/domain/data-view.model';

@Injectable({
    providedIn: 'root'
})

export class ClientToMmrViewService extends CoreApiService<ClientsToMmrView> {
    constructor(
        protected httpService: HttpClient
        , protected storage: StorageMap
    ) {
        super(httpService, 'data/clients-to-mmr-view');
    }
}
